<template>
  <lazy-component @intersected="loadStaticSearches" v-bind:is-intersected="forceIntersect">
    <a-row :gutter="16">
      <a-col span="24">
        <div class="panel panel-default panel-stretch">
          <div class="panel-heading">
            Zoekopties:
          </div>

          <div v-if="loading" class="panel-body no-padding">
            <a-row>
              <a-col :span="4" style="padding: 1.5rem 0 1.5rem 1.5rem;text-align: right;">
                <Skeleton height="20" width="70%" :loading="true"
                          style="margin-bottom: 1.5rem;padding-right:1.5rem;display: inline-block;width: 100%;"></Skeleton>
                <Skeleton height="20" width="70%" :loading="true"
                          style="margin: 1.5rem 0 1.5rem 0;padding-right:1.5rem;display: inline-block;width: 100%;"></Skeleton>
                <Skeleton height="20" width="70%" :loading="true"
                          style="margin: 1.5rem 0 1.5rem 0;padding-right:1.5rem;display: inline-block;width: 100%;"></Skeleton>
                <Skeleton height="20" width="70%" :loading="true"
                          style="margin: 1.5rem 0 1.5rem 0;padding-right:1.5rem;display: inline-block;width: 100%;"></Skeleton>
                <Skeleton height="20" width="70%" :loading="true"
                          style="margin: 1.5rem 0 1.5rem 0;padding-right:1.5rem;display: inline-block;width: 100%;"></Skeleton>
                <Skeleton height="20" width="70%" :loading="true"
                          style="margin: 1.5rem 0 1.5rem 0;padding-right:1.5rem;display: inline-block;width: 100%;"></Skeleton>
                <Skeleton height="20" width="70%" :loading="true"
                          style="margin: 1.5rem 0 1.5rem 0;padding-right:1.5rem;display: inline-block;width: 100%;"></Skeleton>
                <Skeleton height="20" width="70%" :loading="true"
                          style="margin: 1.5rem 0 1.5rem 0;padding-right:1.5rem;display: inline-block;width: 100%;"></Skeleton>
                <Skeleton height="20" width="70%" :loading="true"
                          style="margin: 1.5rem 0 1.5rem 0;padding-right:1.5rem;display: inline-block;width: 100%;"></Skeleton>
                <Skeleton height="20" width="70%" :loading="true"
                          style="margin: 1.5rem 0 1.5rem 0;padding-right:1.5rem;display: inline-block;width: 100%;"></Skeleton>
              </a-col>
              <a-col :span="1">
                <Skeleton height="465" width="2" :loading="true"></Skeleton>
              </a-col>
              <a-col :span="19">
                <a-row>
                  <a-col :span="8" style="padding: 1.5rem 2rem 1.5rem 0;">
                    <Skeleton height="100" width="100%" :loading="true"></Skeleton>
                  </a-col>
                  <a-col :span="8" style="padding: 1.5rem 2rem;">
                    <Skeleton height="100" width="100%" :loading="true"></Skeleton>
                  </a-col>
                  <a-col :span="8" style="padding: 1.5rem 2rem;">
                    <Skeleton height="100" width="100%" :loading="true"></Skeleton>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8" style="padding: 1.5rem 2rem 1.5rem 0;">
                    <Skeleton height="100" width="100%" :loading="true"></Skeleton>
                  </a-col>
                  <a-col :span="8" style="padding: 1.5rem 2rem;">
                    <Skeleton height="100" width="100%" :loading="true"></Skeleton>
                  </a-col>
                  <a-col :span="8" style="padding: 1.5rem 2rem;">
                    <Skeleton height="100" width="100%" :loading="true"></Skeleton>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8" style="padding: 1.5rem 2rem 1.5rem 0;">
                    <Skeleton height="100" width="100%" :loading="true"></Skeleton>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </div>
          <div v-if="!loading" style="width: 100%">
            <a-tabs :tabPosition="mode">
              <a-tab-pane v-for="(category, key) in categories" :key="key" :tab="category.name">
                <StaticSearchButton
                    v-for="staticSearch in staticSearchesByKey(key)"
                    class="staticSearchItem"
                    v-bind:static-search="staticSearch"
                    v-bind:user-id="userId"
                    v-bind:key="staticSearch.extended_key"
                    v-if="staticSearch.count > 0 ||
                    (
                      staticSearch.key !== 'e895baeec559d8d81466a3b2bdfbdd07'
                      && staticSearch.key !== '8afa8005716c85a6ed2f0746dd010670'
                      && staticSearch.key !== '3a1b793d94e84e5cd0f9a7ee1fbf788b'
                      && staticSearch.key !== '6afdd1e41cf7f78004fc075c02ce7974'
                    )"
                />
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </a-col>
    </a-row>
  </lazy-component>
</template>

<script>
import store from '../../../store'
import searchModule from '../store'
import staticSearchApi from '~/api/staticSearch'
import { mapGetters } from 'vuex'
import { Skeleton } from 'vue-loading-skeleton'
import StaticSearchButton from '~/modules/static_search/components/StaticSearchButton'
import ACol from 'ant-design-vue/es/grid/Col'

export default {
  name: 'StaticSearches',
  props: {
    userId: {
      required: true,
      type: [Number, String]
    }
  },
  data () {
    return {
      categories: [],
      values: [],
      exportStatus: 0,
      percentageDone: 0,
      exportHash: null,
      mode: 'left',
      loading: true
    }
  },

  computed: {
    ...mapGetters([
      'forceIntersect'
    ]),
    ...mapGetters('search', [
      'staticSearches',
      'findStaticSearchesByKey'
    ]),
    // ...mapActions('search', [
    //   'setStaticSearches',
    // ]),
  },

  created () {
    if (!store.hasModule('search')) {
      store.registerModule('search', searchModule)
    }
  },

  mounted () {
  },

  methods: {
    loadStaticSearches () {
      this.loading = true
      staticSearchApi.allWithFavorites(this.userId).then((response) => {
        store.dispatch('search/setStaticSearches', response.data)
        staticSearchApi.getCategories().then((response) => {
          this.categories = response
        }).finally(() => {
          this.loading = false
        })
      })
    },
    staticSearchesByKey (key) {
      return this.findStaticSearchesByKey(key)
    },
  },

  components: {
    ACol,
    StaticSearchButton,
    Skeleton,
  },
}
</script>

<style scoped>
table.table th, table.table td {
  padding: 1.5rem 1rem;
}

.staticSearchItem {
  float: left;
  width: 33.33%;
  padding: 1rem 2rem;
}
</style>

<style>
.ant-tabs-tab{
  height: auto !important;
}
</style>